import type { StepType } from "@reactour/tour";
import TourStepContent from "../../wrapper";
import { text } from "@quickpoint.me/shared";

const saveShare: StepType[] = [
	{
		selector: "#action-control-publish",
		content: () => (
			<TourStepContent
				description={() => <span>{text.tourSteps.teacherClickPublish}</span>}
			/>
		),
	},
	{
		selector: "#action-control-qr",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.teacherShareViaLink}
					</span>
				)}
			/>
		),
	},
];

export default saveShare;
